import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDropUp = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.2966 13.615L12.6028 9.282C12.2822 8.906 11.7165 8.906 11.396 9.282L7.70215 13.615C7.24452 14.153 7.61429 15 8.30652 15H15.6941C16.3864 15 16.7561 14.153 16.2966 13.615Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgArrowDropUp);
export default ForwardRef;
